import {OnDestroy, OnInit} from '@angular/core';
import {Component} from '@angular/core';
import {RouterModule} from '@angular/router';
import {WaButtonDirective} from 'angular-awesome';
import {WaCardDirective} from 'angular-awesome';
import {WaTextDirective} from 'angular-awesome';
import {WaTagDirective} from 'angular-awesome';
import {WaDividerDirective} from 'angular-awesome';
import {WaDetailsDirective} from 'angular-awesome';
import {MarkdownComponent} from 'ngx-markdown';
@Component({
	selector:'jwebmp-plugin-material-icons',
	templateUrl:'./MaterialIconsPluginPage.html',
	styles: [],
	styleUrls:['./MaterialIconsPluginPage.scss'
],
	viewProviders:[],
	animations:[],
	providers:[],
	schemas:[],
	preserveWhitespaces:true,
	host:{},
	imports:[
		RouterModule,
		WaButtonDirective,
		WaCardDirective,
		WaTextDirective,
		WaTagDirective,
		WaDividerDirective,
		WaDetailsDirective,
		MarkdownComponent,
],
	standalone:true
})
export class MaterialIconsPluginPage
{
	useGradle = false;
	private _storageListener: any;
	private _customListener: any;
	mdContent_625 = `\`\`\`xml
<dependency>
  <groupId>com.jwebmp.plugins</groupId>
  <artifactId>material-icons</artifactId>
</dependency>
\`\`\``;
	mdContent_626 = `\`\`\`kotlin
implementation("com.jwebmp.plugins:material-icons")
\`\`\``;
	mdContent_627 = `\`\`\`java
var account = new MDIIcon<>(MDIIcons.account);
var settings = new MDIIcon<>(MDIIcons.settings);
\`\`\``;
	mdContent_628 = `\`\`\`java
// Create an MDI icon
var icon = new MDIIcon<>(MDIIcons.account);

// Another icon
var settings = new MDIIcon<>(MDIIcons.settings);
\`\`\``;
	ngOnInit() {
	    const saved = localStorage.getItem('jwebmp-build-tool');
	    if (saved) { this.useGradle = saved === 'gradle'; }
	    this._storageListener = (e: StorageEvent) => {
	        if (e.key === 'jwebmp-build-tool') {
	            this.useGradle = e.newValue === 'gradle';
	        }
	    };
	    this._customListener = (e: any) => {
	        this.useGradle = e.detail;
	    };
	    window.addEventListener('storage', this._storageListener);
	    window.addEventListener('jwebmp-build-tool-change', this._customListener);
	}
	ngOnDestroy() {
	    window.removeEventListener('storage', this._storageListener);
	    window.removeEventListener('jwebmp-build-tool-change', this._customListener);
	}

}
